import { render } from "./incident-treatment.vue?vue&type=template&id=b66922c6&scoped=true"
import script from "./incident-treatment.vue?vue&type=script&lang=js"
export * from "./incident-treatment.vue?vue&type=script&lang=js"

import "./incident-treatment.vue?vue&type=style&index=0&id=b66922c6&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66922c6"]])

export default __exports__